import { NgModule } from '@angular/core';
import { AboutPageModule } from './pages/about/about.module';
import { OkmodalPageModule } from './pages/okmodal/okmodal.module';
import { PdfViewerPageModule } from './pages/pdf-viewer/pdf-viewer.module';
import { UpdatemodalPageModule } from './pages/updatemodal/updatemodal.module';

@NgModule({
  imports: [
    AboutPageModule,
    OkmodalPageModule,
    UpdatemodalPageModule,
    PdfViewerPageModule
  ]
})
export class CommonModulePageModule {}
